// import React from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const DatePickerComponent = ({
//   value,
//   onChange,
//   minDate = new Date(),
//   maxDate,
//   timeIntervals = 1,
//   showTimeSelect = true,
//   placeholderText = "Select a date and time",
//   isClearable = false,
//   dateFormat = "dd/MM/yyyy h:mm aa",
//   className = "",
// }) => {
//   const now = new Date();

//   const getMinTime = () => {
//     if (value && value.toDateString() === now.toDateString()) {
//       // If selected date is today, set min time to current time
//       let minTime = new Date();
//       minTime.setMinutes(now.getMinutes() + 640);
//       return minTime;
//     }
//     return new Date(0, 0, 0, 0, 0); // Midnight for other dates
//   };

//   const getMaxTime = () => {
//     if (value && value.toDateString() === now.toDateString()) {
//       return new Date().setHours(23, 59, 59, 999); // End of today
//     }
//     return new Date(0, 0, 0, 23, 59); // End of day for other dates
//   };

//   const getMinDate = () => {
//     if (value && value.toDateString() === now.toDateString()) {
//       // If selected date is today, set min time to current time
//       let minTime = new Date();
//       minTime.setMinutes(now.getMinutes() + 640);
//       return minTime;
//     }
//     return new Date(0, 0, 0, 0, 0); // Midnight for other dates
//   };

//   return (
//     <DatePicker
//       selected={value}
//       onChange={onChange}
//       minDate={getMinDate()}
//       maxDate={maxDate}
//       showTimeSelect={showTimeSelect}
//       timeIntervals={timeIntervals}
//       dateFormat={dateFormat}
//       placeholderText={placeholderText}
//       isClearable={isClearable}
//       className={className}
//       minTime={getMinTime()}
//       maxTime={getMaxTime()}
//     />
//   );
// };

// export default DatePickerComponent;


import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerComponent = ({
  value,
  onChange,
  minDate = new Date(),
  maxDate,
  timeIntervals = 1,
  showTimeSelect = true,
  placeholderText = "Select a date and time",
  isClearable = false,
  dateFormat = "dd/MM/yyyy h:mm aa",
  className = "",
}) => {
  const now = new Date();
  const additionalHours = 4; // Change this value as needed
  const futureTime = new Date(now.getTime() + additionalHours * 60 * 60 * 1000);

  // Get the minimum selectable date
  const getMinDate = () => {
    return futureTime > now ? futureTime : now;
  };

  // Get the minimum selectable time based on the selected date
  const getMinTime = () => {
    if (value && value.toDateString() === futureTime.toDateString()) {
      return futureTime; // Restrict to the calculated future time
    }
    return new Date(0, 0, 0, 0, 0); // Midnight for other dates
  };

  // Get the maximum selectable time for the selected date
  const getMaxTime = () => {
    if (value && value.toDateString() === now.toDateString()) {
      return new Date().setHours(23, 59, 59, 999); // End of today
    }
    return new Date(0, 0, 0, 23, 59); // End of the day for other dates
  };

  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      minDate={getMinDate()} // Dynamically update min date
      maxDate={maxDate}
      showTimeSelect={showTimeSelect}
      timeIntervals={timeIntervals}
      dateFormat={dateFormat}
      placeholderText={placeholderText}
      isClearable={isClearable}
      className={className}
      minTime={getMinTime()} // Ensure the min time is correctly applied
      maxTime={getMaxTime()}
    />
  );
};

export default DatePickerComponent;
